import { useQuery } from '@tanstack/react-query'

import { getAgreement } from '@/ports'

type Props = {
  id: string
  enabled?: boolean
}

const fetchTerms = async (agreementId: string): Promise<any> => {
  const response = await getAgreement({ agreementId })
  return response?.body
}

export const useGetTerms = ({ id, enabled = false }: Props): any => {
  const {
    data: terms,
    isLoading,
    refetch
  } = useQuery({
    queryKey: [`terms`, id],
    queryFn: () => fetchTerms(id),
    enabled,
    staleTime: 3 * 1000000000
  })

  return { terms, isLoading, refetch }
}
